var map = {
	"./ico-confirmation-you.svg": "gpS4",
	"./ico-facebook.svg": "+zut",
	"./ico-footer.svg": "URp5",
	"./ico-gift-blue.svg": "eSzA",
	"./ico-gift.svg": "F/So",
	"./ico-heart-compounded.svg": "rf88",
	"./ico-heart.svg": "vWLM",
	"./ico-heart_animated.svg": "7hsw",
	"./ico-lines-big.svg": "njdA",
	"./ico-lines-big_animated.svg": "aNmo",
	"./ico-lines.svg": "Va3/",
	"./ico-lines_animated.svg": "trsT",
	"./ico-lock.svg": "fJec",
	"./ico-message.svg": "CoCi",
	"./ico-share.svg": "AQyL",
	"./ico-stamp.svg": "XE3A",
	"./ico-start-here.svg": "61Ln",
	"./ico-stripe.svg": "LVSV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iIHy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/ico\-.*\.svg$
// module id = iIHy
// module chunks = 1